import { useEffect } from 'react'
import { useReactiveVar } from '@apollo/client'
import { useWallet } from '@solana/wallet-adapter-react'
import {
  readStoredPlayWallet,
  resolvePlayWallet,
  selectedWalletAddressVar
} from 'shared/store/play-wallet'
import { userVar } from 'shared/store/user'

/** Keeps the wallet selected for play in sync with the user's linked wallets. */
export const usePlayWalletSync = () => {
  const user = useReactiveVar(userVar)
  const { publicKey } = useWallet()
  const connectedAddress = publicKey?.toBase58() ?? null
  const userId = user?.id
  const wallets = user?.wallets

  useEffect(() => {
    selectedWalletAddressVar(
      userId && wallets ?
        resolvePlayWallet(
          wallets,
          readStoredPlayWallet(userId),
          connectedAddress
        )
      : null
    )
  }, [userId, wallets, connectedAddress])
}
